<template>
  <div id="div-with-loading">
    <vs-popup
      v-if="summary && summary['status']"
      class="rebate-list-details-popup"
      title=""
      :active.sync="rebateListDetailsPopupActive">

      <div class="indented-section">
        <div class="vx-row flex-wrap title-bar">
          <h3>Rebate List Details</h3>

          <div class="flex-wrap client-specific">
            <vs-chip transparent color="dark" class="custom-bg">
              Current Status: <strong class="px-2"> {{ displayRebateStatus }} </strong>
            </vs-chip>
          </div>
        </div>

        <br />

        <!-- Row 1 -->
        <div class="vx-row flex-wrap mt-3">
          <div class="vx-col w-1/4"><strong>Partner Name</strong></div>
          <div class="vx-col w-1/4"><strong>Type</strong></div>
          <div class="vx-col w-1/4"><strong>Period</strong></div>
          <div class="vx-col w-1/4"><strong>List Based</strong></div>
        </div>

        <div class="vx-row flex-wrap">
          <div class="vx-col w-1/4">{{ this.toTitleCase(summary['partner_name']) }}</div>
          <div class="vx-col w-1/4">{{ this.toTitleCase(summary['type']) }}</div> <!-- TODO: Make this dynamic or remove it after consulting -->
          <div class="vx-col w-1/4 break-words">{{ summary['period'] ? summary['period'].join(',') : summary['period'] }}</div>
          <div class="vx-col w-1/4">{{ this.toTitleCase(summary['list_based']) }}</div>
        </div>

        <br />

        <!-- Row 2 -->
        <div class="vx-row flex-wrap">
          <div class="vx-col w-1/4"><strong>List Type</strong></div>
          <div class="vx-col w-1/4"><strong>Payment Mode</strong></div>
          <div class="vx-col w-1/4"><strong>POC 1 Name</strong></div>
          <div class="vx-col w-1/4"><strong>Account Manager</strong></div>
        </div>

        <div class="vx-row flex-wrap">
          <div class="vx-col w-1/4">{{ this.toTitleCase(summary['list_type']) }}</div>
          <div class="vx-col w-1/4">{{ this.toTitleCase(summary['payment_mode']) }}</div>
          <div class="vx-col w-1/4">{{ this.toTitleCase(summary['poc1_name']) }}</div>
          <div class="vx-col w-1/4">{{ this.toTitleCase(summary['am']) }}</div>
        </div>

        <br />

        <!-- Row 3 -->
        <div class="vx-row flex-wrap">
          <div class="vx-col w-1/4"><strong>Net Revenue</strong></div>
          <div class="vx-col w-1/4"><strong>Domain Count</strong></div>
          <div class="vx-col w-1/4"><strong>Sum Of Rebate</strong></div>
          <div class="vx-col w-1/4"><strong>Sum Of Radix Revenue</strong></div>
        </div>

        <div class="vx-row flex-wrap">
          <div class="vx-col w-1/4" v-if="parseFloat(summary['net_revenue']) < 0">-${{ Number(Math.abs(parseFloat(summary['net_revenue'])).toFixed(2)).toLocaleString('en', { minimumFractionDigits: 2 }) }}</div>
          <div class="vx-col w-1/4" v-else>${{ Number(parseFloat(summary['net_revenue']).toFixed(2)).toLocaleString('en', { minimumFractionDigits: 2 }) }}</div>

          <div class="vx-col w-1/4" v-if="summary['domain_count'] && summary['total_domain_count']">{{ Number(parseFloat(summary['domain_count']).toFixed(2)).toLocaleString('en', { minimumFractionDigits: 0 }) }} / {{  Number(parseFloat(summary['total_domain_count']).toFixed(2)).toLocaleString('en', { minimumFractionDigits: 0 }) }}</div>
          <div class="vx-col w-1/4" v-else>{{ Number(parseFloat(summary['domain_count']).toFixed(2)).toLocaleString('en', { minimumFractionDigits: 0 }) }}</div>

          <div class="vx-col w-1/4" v-if="parseFloat(summary['sum_of_rebate']) < 0">${{ Number(parseFloat(summary['sum_of_rebate']).toFixed(2)).toLocaleString('en', { minimumFractionDigits: 2 }) }}</div>
          <div class="vx-col w-1/4" v-else>${{ Number(parseFloat(summary['sum_of_rebate']).toFixed(2)).toLocaleString('en', { minimumFractionDigits: 2 }) }}</div>
          
          <div class="vx-col w-1/4" v-if="parseFloat(summary['sum_of_revenue']) < 0">${{ Number(parseFloat(summary['sum_of_revenue']).toFixed(2)).toLocaleString('en', { minimumFractionDigits: 2 }) }}</div>
          <div class="vx-col w-1/4" v-else>${{ Number(parseFloat(summary['sum_of_revenue']).toFixed(2)).toLocaleString('en', { minimumFractionDigits: 2 }) }}</div>

        </div>

        <hr />

        <div class="vx-row mt-6">
          <div class="vx-col w-2/3 mb-2 form-field">
            <!-- Rebate Calculation -->
            <div class="vx-row w-3/4">
              <div class="vx-col w-full pl-0 pr-0">
                <label class="vs-input--label inline-flex pb-2">
                  {{
                    labels['calculationSheetLabel']
                  }}
                </label>
                <div class="upload-input relative">
                  <vs-button
                    class="upload-btn flex align-center"
                    style="text-overflow: ellipsis"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-file-text"
                    @click="downloadFile(summary['file_url'])">
                    {{
                      summary['file_name']
                    }}
                  </vs-button>
                  <span style="
                      position: absolute;
                      right: 0;
                      bottom: 0;
                      transform: translate(-80%, -10%);">
                    <feather-icon
                      icon="DownloadIcon"
                      color="primary"
                      class="primary"
                      style="width: 15px; height: 15px; color: #000000"/>
                  </span>
                </div>
                <div class="upload-input relative mt-2">
                  <vs-button
                    v-if="summary['error_file_url']"
                    class="upload-btn flex align-center"
                    style="text-overflow: ellipsis"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-file-text"
                    @click="downloadFile(summary['error_file_url'])">
                    {{
                      summary['error_file_name']
                    }}
                  </vs-button>
                  <span style="
                      position: absolute;
                      right: 0;
                      bottom: 0;
                      transform: translate(-80%, -10%);">
                    <feather-icon
                      icon="DownloadIcon"
                      color="primary"
                      class="primary"
                      style="width: 15px; height: 15px; color: #000000"/>
                  </span>
                </div>
              </div>
            </div>
            <!-- Rebate Calculation  -->

            <!-- Invoice & Credit Note -->
            <div class="vx-row w-3/4">
              <!-- Invoice -->
              <div class="vx-col pl-0" v-if="labels['clientInvoiceLabel']" :class="labels['creditNoteLabel']  && invoiceData['creditNote_file_name'] !== '' ? 'w-1/2' : 'w-full pr-0'">
                <label class="vs-input--label inline-flex pb-2 mt-4">{{ labels['clientInvoiceLabel'] }}</label>
                <div class="upload-input relative">
                  <vs-button
                    class="upload-btn flex align-center"
                    style="text-overflow: ellipsis"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-file-text"
                    @click="downloadFile(invoiceData['invoice_file_url'])">
                      {{ truncate(invoiceData['invoice_file_name'], 12) }}
                    </vs-button>
                  <span
                    style="
                      position: absolute;
                      right: 0;
                      bottom: 0;
                      transform: translate(-80%, -10%);">
                    <feather-icon
                      icon="DownloadIcon"
                      color="primary"
                      class="primary"
                      style="width: 15px; height: 15px; color: #000000"
                    />
                  </span>
                </div>
              </div>
              <!-- Invoice -->

              <!-- Credit Note -->
              <div class="vx-col w-1/2 pr-0" v-if="labels['creditNoteLabel'] && invoiceData['creditNote_file_name'] !== ''">
                <label class="vs-input--label inline-flex pb-2 mt-4">{{ labels['creditNoteLabel'] }}</label>
                <div class="upload-input relative">
                  <vs-button
                    class="upload-btn flex align-center"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-file-text"
                    @click="downloadFile(invoiceData['creditNote_file_url'])">
                      {{ truncate(invoiceData['creditNote_file_name'], 12) }}
                  </vs-button>
                  <span
                    style="
                      position: absolute;
                      right: 0;
                      bottom: 0;
                      transform: translate(-80%, -10%);">
                    <feather-icon
                      icon="DownloadIcon"
                      color="primary"
                      class="primary"
                      style="width: 15px; height: 15px; color: #000000"/>
                  </span>
                </div>
              </div>
              <!-- Credit Note -->
            </div>
            <!-- Invoice & Credit Note -->

            <!-- PT Ticket -->
            <div class="vx-row w-3/4" v-if="summary['status'] === statusConstants['Payment Queued'] || summary['status'] === statusConstants['Paid']">
              <div class="vx-col w-full pl-0 pr-0 mt-3">
                <label class="vs-input--label inline-flex pb-2 mt-4">Paytrack Details:</label>
                <div>
                  <vs-button
                    icon-pack="feather"
                    icon="icon-external-link"
                    id="button-with-loading"
                    color="primary"
                    type="filled"
                    class="custom-btn primary-btn px-10 py-3 w-full"
                    icon-after
                    @click="navigateToPT">
                    View Paytrack Ticket
                  </vs-button>
                </div>
              </div>
            </div>
            <!-- PT Ticket -->
          </div>

          <div class="vx-col w-1/3 mb-2">
            <label v-if="showCalculationActions" class="vs-input--label inline-flex pb-2">Rebate Calculation Actions:</label>
            <div v-if="showCalculationActions" class="flex" style="justify-content: flex-start;">
              <!-- Approve -->
              <div :style="summary['status'] === 'rebates_calculated' && isLocalRule ? 'margin-right: 1rem' : ''">
                <vs-button
                  v-if="summary['status'] === 'rebates_calculated' && isLocalRule"
                  icon-pack="feather"
                  icon="icon-check"
                  id="button-with-loading"
                  color="primary"
                  type="filled"
                  class="custom-btn accept-btn"
                  @click="approveRebateSummary()">
                  Accept
                </vs-button>

                <vs-button
                  v-else-if="flags['summaryAccepted']"
                  icon-pack="feather"
                  icon="icon-check"
                  id="button-with-loading"
                  color="primary"
                  type="filled"
                  class="custom-btn accepted-btn">
                  Accepted
                </vs-button>
              </div>
              <!-- Reject -->
              <div :style="summary['status'] === 'rebates_calculated' && isLocalRule ? 'margin-right: 1rem' : ''">
                <vs-button
                  v-if="summary['status'] === 'rebates_calculated' && isLocalRule"
                  icon-pack="feather"
                  icon="icon-x"
                  id="button-with-loading"
                  color="danger"
                  type="filled"
                  class="custom-btn reject-btn"
                  @click="rejectRebateSummary()">
                  Reject
                </vs-button>

                <vs-button
                  v-else-if="flags['summaryRejected']"
                  icon-pack="feather"
                  icon="icon-x"
                  id="button-with-loading"
                  color="danger"
                  type="filled"
                  class="custom-btn rejected-btn">
                  Rejected
                </vs-button>
              </div>
              <!-- Abandon Rebate File -->
              <div>
                <vs-button
                  v-if="summary['status'] === 'rebates_calculated' && isLocalRule"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  id="button-with-loading"
                  color="dark"
                  type="filled"
                  class="custom-btn abandon-btn"
                  @click="abandonRebateFile()">
                  Abandon
                </vs-button>
              </div>
            </div>


            <label v-if="showInvoiceActions" class="vs-input--label inline-flex pb-2" :class="summary['error_file_url'] ? 'margin-top-actions' : 'mt-5'">BI Invoice Actions:</label>
            <div v-if="showInvoiceActions" class="flex flex-wrap" style="justify-content: flex-start;">
              <div :style="summary['status'] === statusConstants['Invoice Received'] && summary['payment_mode'] !== 'cnic' && isLocalRule ? 'margin-right: 1rem' : ''">
                <vs-button
                  v-if="summary['status'] === statusConstants['Invoice Received'] && summary['payment_mode'] !== 'cnic' && isLocalRule"
                  icon-pack="feather"
                  icon="icon-check"
                  id="button-with-loading"
                  color="primary"
                  type="filled"
                  class="custom-btn accept-btn"
                  @click="acceptInvoice()">
                  Accept
                </vs-button>

                <vs-button
                  v-else-if="flags['invoiceAccepted'] && summary['payment_mode'] !== 'cnic'"
                  icon-pack="feather"
                  icon="icon-check"
                  id="button-with-loading"
                  color="primary"
                  type="filled"
                  class="custom-btn accepted-btn">
                  Accepted
                </vs-button>
              </div>
              <div>
                <vs-button
                  v-if="summary['status'] === statusConstants['Invoice Received'] && summary['payment_mode'] !== 'cnic' && isLocalRule"
                  icon-pack="feather"
                  icon="icon-x"
                  id="button-with-loading"
                  color="danger"
                  type="filled"
                  class="custom-btn reject-btn"
                  @click="rejectInvoice()">
                  Reject
                </vs-button>
                    
                <vs-button
                  v-else-if="flags['invoiceRejected'] && summary['payment_mode'] !== 'cnic'"
                  icon-pack="feather"
                  icon="icon-x"
                  id="button-with-loading"
                  color="danger"
                  type="filled"
                  class="custom-btn rejected-btn">
                  Rejected
                </vs-button>
              </div>
            </div>

            <!-- <label v-if="showPTDetails" class="vs-input--label inline-flex pb-2 mt-6">PT Details:</label>
            <div v-if="showPTDetails">
              <div>Ticket #: {{ invoiceData['pt_ticket_id'] }}</div>
              <div class="mt-1">Status: {{ invoiceData['pt_status'] }}</div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Rebates Summary component START -->
      <RebatesSummarySheet
        v-if="summary['status'] != 'pending'"
        :source="'rebateListDetails'"
        :sharedListData="rebatesSummaryData">
      </RebatesSummarySheet>
      <!-- Rebates Summary component END -->
    </vs-popup>

    <!-- Error/Success Prompt -->
    <custom-prompt
      :activePrompt.sync="customPrompt['activePrompt']"
      :title="customPrompt['title']"
      :buttonText="customPrompt['buttonText']"
      :acceptText="customPrompt['acceptText']"
      :accept="customPrompt['accept']">

      <div class="con-content" slot="content">
        <p>{{ customPrompt['message'] }}</p> <br> <textarea v-model='reason' class='reject-popup-textarea' placeholder='Type Here...'></textarea>
      </div>
    </custom-prompt>
  </div>
</template>

<script>
import vSelect from "vue-select";
import RebatesSummarySheet from "@/components/ag-grid-tables/rebates/rebates-summary/RebatesSummarySheet.vue";
import statusConstants from "@/json/statusConstants.json";

export default {
  name: "RebateListDetails",
  components: {
    "v-select": vSelect,
    RebatesSummarySheet,
  },
  data() {
    return {
      rebateListDetailsPopupActive: false,
      statusConstants: statusConstants,
      type: '',
      bi_table_id: [],
      id: '',
      summary: {
        new_reseller_id: '',
        status: '',
        partner_name: '',
        type: '',
        period: '',
        period_other: '',
        file_name: '',
        file_url: '',
        error_file_name: '',
        error_file_url: '',
        list_based: '',
        list_frequency: '',
        list_type: '',
        payment_mode: '',
        poc1_name: '',
        am: '',
        net_revenue: '',
        domain_count: '',
        total_domain_count: '',
        sum_of_rebate: '',
        sum_of_revenue: '',
      },
      invoiceData: {
        invoice_file_name: '',
        invoice_file_url: '',
        creditNote_file_name: '',
        creditNote_file_url: '',
        pt_ticket_id: '',
        pt_status: ''
      },
      labels: {
        calculationSheetLabel: '',
        clientInvoiceLabel: '',
        creditNoteLabel: '',
      },
      rawResponse: null,
      rebatesSummaryData: [],
      showCalculationActions: false,
      showInvoiceActions: false,
      showPTDetails: false,
      // Custom Dialog props
      customPrompt: {
        activePrompt: false,
        title: '',
        buttonText: '',
        acceptText: '',
        message: '',
      },
      flags: {
        summaryAccepted: false,
        summaryRejected: false,
        invoiceAccepted: false,
        invoiceRejected: false
      },
      reason: ''
    };
  },
  watch: {
    'summary.status'() {
      this.flags['summaryAccepted'] = [statusConstants['Approved by Radix'], statusConstants['Approved by Partner'], statusConstants['Invoice Received'], statusConstants['Invoice Approved'], statusConstants['Invoice Rejected'], statusConstants['Payment Queued'], statusConstants['Paid']].some(x => x == this.summary['status']);
      this.flags['summaryRejected'] = [statusConstants['Rejected by Radix'], statusConstants['Rejected by Partner']].some(x => x == this.summary['status']);
      this.flags['invoiceAccepted'] = [statusConstants['Invoice Approved'], statusConstants['Payment Queued'], statusConstants['Paid']].some(x => x == this.summary['status']);
      this.flags['invoiceRejected'] = [statusConstants['Invoice Rejected']].some(x => x == this.summary['status']);
    }
  },
  computed: {
    isLocalRule() {
      return this.$acl.check('isSuperAdmin') || this.$acl.check('isChannelAdmin') || this.$acl.check('isBIAdmin') || this.$acl.check('isBIUser');
    },
    displayRebateStatus() {
      return Object.keys(statusConstants).find(key => statusConstants[key] == this.summary['status']);
    }
  },
  mounted() {
    let self = this;

    self.$root.$on('openRebateListDetailsPopup', (args) => {
      args = args.data;
      self.summary['new_reseller_id'] = args['new_reseller_id'];
      self.summary['status'] = args['status'];
      self.summary['falcon_file_name'] = args['falcon_file_name'];

      self.populatePopupData();

      self.rebateListDetailsPopupActive = true;
    });
  },
  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 0.8,
      });
    },
    hideLoadingInDiv() {
      this.$vs.loading.close('#div-with-loading > .con-vs-loading');
    },
    // A status change went through: the popup and the table behind it are both out of date now
    finishStatusChange() {
      this.hideLoadingInDiv();
      this.rebateListDetailsPopupActive = false;

      // RebatesCalculator.vue and CNICCompiler.vue both listen for this and re-read their table
      this.$root.$emit('tableRefresh');
    },
    // The API refused the action because the rebate already moved on, or something else broke
    handleActionError(error) {
      let response = error.response;
      let message = response && response.data ? response.data.message : null;

      if (response && response.status === 409) {
        this.$vs.notify({
          color: 'warning',
          title: 'Status already changed',
          text: message || 'This rebate has already moved on.',
          time: 6000,
        });

        // Nothing was written, but what is on screen is stale, so pull the real status back in
        this.finishStatusChange();
        return;
      }

      this.hideLoadingInDiv();

      this.$vs.notify({
        color: 'danger',
        title: 'Something went wrong',
        text: message || 'Please contact the server admin',
      });

      console.log(error);
    },
    populatePopupData() {
      this.$axiosSecure
        .get(`/rebates/summary/${this.summary['new_reseller_id']}/${this.summary['status']}/${this.summary['falcon_file_name']}`)
        // .get(`/rebates/summary/${this.summary['new_reseller_id']}/${this.summary['status']}`)
        .then((response) => {
          this.rawResponse = response.data.data;
          this.id = response.data.data.id;
          this.bi_table_id = response.data.data.bi_table_id;
          this.summary['status'] = response.data.data.status;
          this.summary['partner_name'] = response.data.data.rebates_summary_data[0].new_reseller_name;
          this.summary['type'] = response.data.data.rebates_summary_data[0].file_format ? response.data.data.rebates_summary_data[0].file_format : 'Simple Bundled';
          this.summary['period'] = response.data.data.rebates_summary_data[0].period;
          this.summary['period_other'] = response.data.data.rebates_summary_data[0].period_other;
          this.summary['file_name'] = response.data.data.rebates_summary_data[0].file_name;
          this.summary['file_url'] = response.data.data.rebates_summary_data[0].file_url;
          this.summary['error_file_name'] = response.data.data.rebates_summary_data[0].error_file_name;
          this.summary['error_file_url'] = response.data.data.rebates_summary_data[0].error_file_url;
          this.summary['list_based'] = response.data.data.rebates_summary_data[0].list_based;
          this.summary['list_frequency'] = response.data.data.rebates_summary_data[0].list_frequency;
          this.summary['list_type'] = response.data.data.rebates_summary_data[0].list_type;
          this.summary['payment_mode'] = response.data.data.rebates_summary_data[0].payment_mode;
          this.summary['poc1_name'] = response.data.data.rebates_summary_data[0].poc_details[0].name;
          this.summary['am'] = response.data.data.rebates_summary_data[0].am;
          this.summary['net_revenue'] = response.data.data.rebates_summary_data[0].net_revenue;
          this.summary['domain_count'] = response.data.data.rebates_summary_data[0].domain_count;
          this.summary['total_domain_count'] = response.data.data.rebates_summary_data[0].uploaded_domain_count;
          this.summary['sum_of_rebate'] = response.data.data.rebates_summary_data[0].sum_of_rebates;
          this.summary['sum_of_revenue'] = response.data.data.rebates_summary_data[0].sum_radix_revenue;
          // this.summary['status'] = 'payment_queued';

          if(response.data.data.rebates_status && response.data.data.rebates_status[0]) {
            this.invoiceData['invoice_file_name'] = response.data.data.rebates_status[0].invoice_file_name;
            this.invoiceData['invoice_file_url'] = response.data.data.rebates_status[0].invoice_path ? process.env.VUE_APP_API + '/storage/' + response.data.data.rebates_status[0].invoice_path.split('public/')[1] : null;
            this.invoiceData['creditNote_file_name'] = response.data.data.rebates_status[0].credit_note_file_name ? response.data.data.rebates_status[0].credit_note_file_name : '';
            this.invoiceData['creditNote_file_url'] = response.data.data.rebates_status[0].credit_note_path ? process.env.VUE_APP_API + '/storage/' + response.data.data.rebates_status[0].credit_note_path.split('public/')[1] : null;
            this.invoiceData['pt_ticket_id'] = response.data.data.rebates_status[0].pt_ticket_id;
            this.invoiceData['pt_status'] = response.data.data.rebates_status[0].pt_status;

            if(this.invoiceData['invoice_file_name']) {
              this.labels['clientInvoiceLabel'] = 'Download Invoice';
            }

            if(this.invoiceData['creditNote_file_name']) {
              this.labels['creditNoteLabel'] = 'Download Credit Note';
            }
          } else {
            this.invoiceData = {
              invoice_file_name: null,
              invoice_file_url: null,
              creditNote_file_name: null,
              creditNote_file_url: null,
              pt_ticket_id: null,
              pt_status: null
            }
            this.labels['clientInvoiceLabel'] = null;
            this.labels['creditNoteLabel'] = null;
          }


          this.rebatesSummaryData = response.data.data.rebates_summary_detail;

          this.filterBasedOnStatus();

          if (this.gridApi) {
            setTimeout(() => {
              // this.initSelectedAllFlag();
            }, 1000);
          }
        })
        .catch((error) => {
          if(error.response && error.response.status == 505) {
            // Reload because new data is available
            window.location.reload();
          } else {
            // Error notification
            this.$vs.notify({
              color: 'danger',
              title: 'Something went wrong',
              text: 'Please contact the server admin',
            });
  
            // Clear Listing Count
            this.$store.dispatch('clearListingCount');
          }
        });
    },
    filterBasedOnStatus() {
      switch (this.summary['status']) {
        case statusConstants['Pending']: {
          this.labels['calculationSheetLabel'] = 'Upload Rebate Calculation Sheet';
          this.labels['clientInvoiceLabel'] = null;
          this.labels['creditNoteLabel'] = null;
          this.showCalculationActions = false;
          this.showInvoiceActions = false;
          this.showPTDetails = false;
          break;
        }

        case statusConstants['Rebates Calculated']: {
          this.labels['calculationSheetLabel'] = 'Download Rebate Calculation Sheet';
          this.labels['clientInvoiceLabel'] = null;
          this.labels['creditNoteLabel'] = null;
          this.showCalculationActions = true;
          this.showInvoiceActions = false;
          this.showPTDetails = false;
          break;
        }

        case statusConstants['Approved by Radix']: {
          this.labels['calculationSheetLabel'] = 'Download Rebate Calculation Sheet';
          this.labels['clientInvoiceLabel'] = null;
          this.labels['creditNoteLabel'] = null;
          this.showCalculationActions = true;
          this.showInvoiceActions = false;
          this.showPTDetails = false;
          break;
        }

        case statusConstants['Rejected by Radix']: {
          this.labels['calculationSheetLabel'] = 'Download Rebate Calculation Sheet';
          this.labels['clientInvoiceLabel'] = null;
          this.labels['creditNoteLabel'] = null;
          this.showCalculationActions = true;
          this.showInvoiceActions = false;
          this.showPTDetails = false;
          break;
        }

        case statusConstants['Approved by Partner']: {
          this.labels['calculationSheetLabel'] = 'Download Rebate Calculation Sheet';
          this.labels['clientInvoiceLabel'] = null;
          this.labels['creditNoteLabel'] = null;
          this.showCalculationActions = true;
          this.showInvoiceActions = false;
          this.showPTDetails = false;
          break;
        }

        case statusConstants['Rejected by Partner']: {
          this.labels['calculationSheetLabel'] = 'Download Rebate Calculation Sheet';
          this.labels['clientInvoiceLabel'] = null;
          this.labels['creditNoteLabel'] = null;
          this.showCalculationActions = true;
          this.showInvoiceActions = false;
          this.showPTDetails = false;
          break;
        }

        case statusConstants['Invoice Received']: {
          this.labels['calculationSheetLabel'] = 'Download Rebate Calculation Sheet';
          this.labels['clientInvoiceLabel'] = 'Download Invoice';
          this.labels['creditNoteLabel'] = 'Download Credit Note';
          this.showCalculationActions = true;
          this.showInvoiceActions = true;
          this.showPTDetails = false;
          break;
        }

        case statusConstants['Invoice Approved']: {
          this.labels['calculationSheetLabel'] = 'Download Rebate Calculation Sheet';
          this.labels['clientInvoiceLabel'] = 'Download Invoice';
          this.labels['creditNoteLabel'] = 'Download Credit Note';
          this.showCalculationActions = true;
          this.showInvoiceActions = true;
          this.showPTDetails = false;
          break;
        }

        case statusConstants['Invoice Rejected']: {
          this.labels['calculationSheetLabel'] = 'Download Rebate Calculation Sheet';
          this.labels['clientInvoiceLabel'] = 'Download Invoice';
          this.labels['creditNoteLabel'] = 'Download Credit Note';
          this.showCalculationActions = true;
          this.showInvoiceActions = true;
          this.showPTDetails = false;
          break;
        }

        case statusConstants['Payment Queued']: {
          this.labels['calculationSheetLabel'] = 'Download Rebate Calculation Sheet';
          this.labels['clientInvoiceLabel'] = 'Download Invoice';
          this.labels['creditNoteLabel'] = 'Download Credit Note';
          this.showCalculationActions = true;
          this.showInvoiceActions = true;
          this.showPTDetails = true;
          break;
        }

        case statusConstants['Paid']: {
          this.labels['calculationSheetLabel'] = 'Download Rebate Calculation Sheet';
          this.labels['clientInvoiceLabel'] = 'Download Invoice';
          this.labels['creditNoteLabel'] = 'Download Credit Note';
          this.showCalculationActions = true;
          this.showInvoiceActions = true;
          this.showPTDetails = true;
          break;
        }
      }
    },
    // NOTE: What happens when Rebate Summary is accepted
    approveRebateSummary() {
      this.openLoadingInDiv();

      let payload = {
        id: [this.id]
      }

      setTimeout(() => {
        this.$axiosSecure
        .post(`/rebates/summary/approve`, payload)
        .then(() => {
          // Status changed on the server, so this screen is stale: close it and reload the table
          this.finishStatusChange();
        })
        .catch((error) => {
          this.handleActionError(error);
        })
      }, 500)
    },
    // NOTE: What happens when Rebate Summary is rejected
    rejectRebateSummary() {
      this.openLoadingInDiv();

      let payload = {
        id: [this.id]
      }

      this.$axiosSecure
      .post(`/rebates/summary/reject`, payload)
      .then(() => {
        // Status changed on the server, so this screen is stale: close it and reload the table
        this.finishStatusChange();
      })
      .catch((error) => {
        this.handleActionError(error);
      })
    },
    // NOTE: What happens when Rebate File is abandoned
    abandonRebateFile() {
      this.customPrompt['activePrompt'] = true;
      this.reason = '';
      this.customPrompt['title'] = 'Are you sure? This action cannot be undone.';
      this.customPrompt['color'] = 'danger';
      this.customPrompt['acceptText'] = 'Yes, Abandon';
      this.customPrompt['message'] = 'Please enter the reason for abandoning the file in the box below.';
      this.customPrompt['accept'] = () => {
        this.openLoadingInDiv();

        let payload = {
          falcon_file_name: this.rawResponse['falcon_file_name'],
          client_id: this.rawResponse['new_reseller_id'],
          abandon_reason: this.reason || 'No reason provided',
        }

        this.$axiosSecure
        .post(`/abandon-rebate`, payload)
        .then(() => {
          // File abandoned, so this screen is stale: close it and reload the table
          this.finishStatusChange();
        })
        .catch((error) => {
          this.handleActionError(error);
        })
      }
    },
    // NOTE: What happens when invoice is accepted
    acceptInvoice() {
      this.openLoadingInDiv();

      let payload = [{
        // new_reseller_id: this.summary['new_reseller_id']
        summary_id: this.id
      }]

      this.$axiosSecure
      .post(`/rebates/invoice/approve`, payload)
      .then(() => {
        // Status changed on the server, so this screen is stale: close it and reload the table
        this.finishStatusChange();
      })
      .catch((error) => {
        this.handleActionError(error);
      })
    },
    // NOTE: What happens when Invoice is rejected
    rejectInvoice() {
      this.customPrompt['activePrompt'] = true;
      this.reason = '';
      this.customPrompt['title'] = 'Provide Information';
      this.customPrompt['color'] = 'primary';
      this.customPrompt['acceptText'] = 'Submit';
      this.customPrompt['message'] = 'Please enter the reason for rejecting the invoice in the box below. This will be sent directly to the client so they can take further action.';
      this.customPrompt['accept'] = () => {
        let payload = [{
          // new_reseller_id: this.summary['new_reseller_id'],
          summary_id: this.id,
          reason: this.reason
        }]
        
        this.openLoadingInDiv();
        this.$axiosSecure
        .post(`/rebates/invoice/reject`, payload)
        .then(() => {
          // Status changed on the server, so this screen is stale: close it and reload the table
          this.finishStatusChange();
        })
        .catch((error) => {
          this.handleActionError(error);
        })
      }
    },
    downloadFile(url) {
      window.open(url, '_blank');
    },
    navigateToPT() {
      window.open(process.env.VUE_APP_PT_LINK + this.invoiceData['pt_ticket_id'], '_blank')
    }
  },
  destroyed() {
    this.$root.$off('openRebateListDetailsPopup');
  },
};
</script>
